/* @flow strict */

import * as React from 'react';
import EventPageDesignMenu from './ticketSections/menu';
import EventPageTicketPreviewCustomizeModal from './modal/';
import Loader from '/client/src/components/Loader';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import EmbedCheckout from '/client/src/components/checkout/';
import _ from 'lodash';
import { convertToLocalTime } from '/client/src/utils/jstz';
import eventInfo from './eventInfo.module.css';
import { format } from '../../../../utils/amountTransformation';
import { currency } from '../../../../constants';

type PropsType = {
  eventId: string | number,
  isShowModal: boolean,
  handleToggleModal: (boolean) => void,
  upPartsData: ({}) => void,
  eventDetail: {},
  theme: string,
  partsData: [],
  eventContext: any
};

class TicketPreview extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      showTickets: true,
      isShowDescription: true,
      countedTotalDonation: 0,
      editablePart: null
    };
  }

  handleLoaded = (error: Error, { data }: any) => {
    if (error) {
      console.log(error);
    }

    this.props.upPartsData(data.result.parts);
  };

  handleUpdateParts = (newParts: []) => {
    this.props.upPartsData(newParts);
  };

  handleSetDonatedTotal = (countedTotalDonation: number) => {
    const current = _.clone(this.state.countedTotalDonation);

    this.setState({ countedTotalDonation: current + countedTotalDonation });
  };

  handleShowHideDescription = (toState: boolean) => {
    this.setState({ isShowDescription: toState });
  }

  setEditablePart = (editablePart: any) => {
    this.setState({
      editablePart
    }, () => this.props.handleToggleModal(true));
  }

  handleToggleModal = (status: boolean) => {
    this.setState({
      editablePart: null
    });
    this.props.handleToggleModal(status);
  }

  render(): React.Element<'div'> {
    const {
      showTickets,
      isShowDescription,
      countedTotalDonation,
      editablePart
    } = this.state;
    const { eventId, isShowModal, handleToggleModal, partsData } = this.props;

    let { eventDetail } = this.props.eventContext;

    if (!eventDetail) {
      // Case for create new Event without uses context
      eventDetail = this.props.eventDetail;
    }

    const x1 = _.get(eventDetail, 'image_crop_info.x1', 0);
    const x2 = _.get(eventDetail, 'image_crop_info.x2', 0);
    const y1 = _.get(eventDetail, 'image_crop_info.y1', 0);
    const y2 = _.get(eventDetail, 'image_crop_info.y2', 0);

    const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})`;
    const isReadonlyPermission = _.get(eventDetail, 'permission', 'Write') === 'Read';

    return (
      <div className="splash-editor-body" style={{ minHeight: '500px' }}>
        <div className={`splash-page ${this.props.theme === 'Light' ? 'splash_light' : 'splash_dark'}`}>
          {isShowDescription &&
            <EventPageDesignMenu
              showTickets={showTickets}
              parts={partsData}
            />
          }

          <div className={`splash-sections ${isShowDescription ? '' : 'isShowDescription'}`}>

            {isShowDescription &&
              <>
                <div id="home" className="splash-section splash-section-event">
                   {!!_.size(eventDetail.donations) &&
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '13px 38px',
                        background: '#5AD4B8',
                        fontSize: '20px',
                        fontWeight: '600'
                      }}
                    >
                      <div>Help us reach our donation goal!</div>
                      <div>
                        {format(currency[this.context.profileCurrent.currency], countedTotalDonation)}
                        <span> donated so far</span>
                      </div>
                    </div>
                   }
                  {eventDetail.image_url && !eventDetail.skip_event_landing_page &&
                    <div className="splash-container-fluid">
                      <div className="splash-event-info">
                        <div className="splash-info-img">
                          <img
                            src={`${eventDetail.image_url}?${imageUrlParams}`}
                            alt={eventDetail.name}
                          />
                        </div>
                      </div>
                    </div>
                  }
                </div>

                <div className={eventInfo.container}>
                  <div className={eventInfo.info}>
                    {eventDetail.show_event_time_and_date &&
                      <div className={eventInfo.left}>
                        <div className={eventInfo.month}>
                          {eventDetail ?
                            convertToLocalTime(eventDetail.begin_time_utc, eventDetail.time_zone_id, 'MMM')
                            :
                            ''
                          }
                        </div>
                        <div className={eventInfo.day}>
                          {eventDetail ?
                            convertToLocalTime(eventDetail.begin_time_utc, eventDetail.time_zone_id, 'DD')
                            :
                            ''
                          }
                        </div>
                      </div>
                    }
                    <div className={eventInfo.right}>
                      <div className={eventInfo.name}>{eventDetail ? eventDetail.name : ''}</div>
                      {eventDetail && eventDetail.location &&
                        <div>{eventDetail.location}</div>
                      }
                      {eventDetail.show_event_time_and_date &&
                        <div>
                          {eventDetail ?
                            convertToLocalTime(eventDetail.begin_time_utc, eventDetail.time_zone_id, 'MMM Do, h:mm A')
                            :
                            ''}
                          <span> - </span>
                          {eventDetail ?
                            convertToLocalTime(eventDetail.end_time_utc, eventDetail.time_zone_id, 'MMM Do, h:mm A z')
                            :
                            ''
                          }
                        </div>
                      }
                    </div>
                  </div>

                  {eventDetail && !eventDetail.skip_event_landing_page &&
                    <div
                      className={eventInfo.description}
                      // eslint-disable-next-line
                      dangerouslySetInnerHTML={{ __html: eventDetail.long_description }}
                    />
                  }
                </div>
              </>
            }

            <Loader
              url={`/api/v1/1/splashpages/${eventId}`}
              onLoaded={this.handleLoaded}
            >
              <>
                {eventDetail.show_tickets &&
                  <div
                    id="tickets"
                    className={`splash-section splash-section-tickets ${this.props.theme === 'Dark' ? 'splash_dark' : ''}`}
                    style={{ minHeight: '400px' }}
                  >
                    <div className="splash-container">
                      <EmbedCheckout
                        eventDetail={eventDetail}
                        handleSetDonatedTotal={this.handleSetDonatedTotal}
                        handleShowHideDescription={this.handleShowHideDescription}
                      />
                    </div>
                  </div>
                }
                {_.map(
                  _.sortBy(partsData, (p: {}): number => p.placement_index),
                  (p: {}, pi: number): React.Element<'li'> => {
                  try {
                    let Component;

                    if (p.type === 'Map') {
                      Component = require('./ticketSections/map/index.jsx').default;
                    } else {
                      Component = require(`./ticketSections/${_.toLower(p.type)}.jsx`).default;
                    }

                    return (
                      <Component
                        eventDetail={eventDetail}
                        p={p}
                        parts={partsData}
                        key={`Component-${pi}`}
                        {...this.props}
                        onHandleUpdateParts={this.handleUpdateParts}
                        setEditablePart={this.setEditablePart}
                      />
                    );
                  } catch (e) {
                    console.log(e);
                  }
                })}

                {isShowModal &&
                  <EventPageTicketPreviewCustomizeModal
                    isOpen={isShowModal}
                    editablePart={editablePart}
                    handleShowModal={this.handleToggleModal}
                    parts={partsData}
                    {...this.props}
                  />
                }
              </>
            </Loader>
            {
              !isReadonlyPermission &&
            <div className="splash-section splash-section-add">
              <a
                className="splash-container splash-add"
                onClick={(e: any) => {
                  e.preventDefault();
                  handleToggleModal(true);
                }}
              >
                <i className="fa fa-plus-circle" />
                <span style={{ paddingLeft: '10px' }}>Add a New Section</span>
              </a>
            </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default TicketPreview;
